(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["clothzz-scroll-top"] && !Shopify.designMode) return;
  try {
    const scrollTopButton = document.getElementById('ClothzzScrollTop');
if (scrollTopButton && !scrollTopButton.dataset.initialized) {
  scrollTopButton.dataset.initialized = 'true';
  let frame = 0;
  const update = () => {
    frame = 0;
    const top = Math.max(0, window.scrollY || 0);
    const distance = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - window.innerHeight;
    const progress = distance > 0 ? Math.min(1, top / distance) : 0;
    scrollTopButton.hidden = top <= 20 || distance <= 0;
    scrollTopButton.style.setProperty('--scroll-progress', String(progress));
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('pageshow', schedule);
  scrollTopButton.addEventListener('click', () => {
    window.scrollTo({top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    observer.observe(document.body);
    observer.observe(document.documentElement);
  }
  update();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cz-home-shared"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cz-gift-carousel')) {
 customElements.define('cz-gift-carousel', class extends HTMLElement {
  connectedCallback() {
   if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
   this.track=this.querySelector('[data-czh-track]');this.paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovered=false;
   const on=(el,type,fn)=>el.addEventListener(type,fn,{signal});
   on(this.querySelector('[data-czh-prev]'),'click',()=>this.move(-1));on(this.querySelector('[data-czh-next]'),'click',()=>this.move(1));
   on(this.track,'dragstart',event=>event.preventDefault());
   on(this.track,'pointerdown',event=>{
    if(event.pointerType!=='mouse'||event.button!==0)return;
    this.suppressClick=false;this.drag={id:event.pointerId,x:event.clientX,left:this.track.scrollLeft,moved:false};
   });
   on(window,'pointermove',event=>{
    const drag=this.drag;if(!drag||event.pointerId!==drag.id)return;
    const distance=event.clientX-drag.x;
    if(!drag.moved&&Math.abs(distance)<6)return;
    if(!drag.moved){drag.moved=true;this.track.classList.add('czh-dragging');this.track.setPointerCapture(drag.id);}
    event.preventDefault();this.track.scrollLeft=drag.left-distance;
   });
   const endDrag=event=>{
    const drag=this.drag;if(!drag||event.pointerId!==drag.id)return;
    this.suppressClick=drag.moved;this.drag=null;this.track.classList.remove('czh-dragging');
    if(this.track.hasPointerCapture(drag.id))this.track.releasePointerCapture(drag.id);
   };
   on(window,'pointerup',endDrag);on(window,'pointercancel',endDrag);on(this.track,'lostpointercapture',endDrag);
   this.track.addEventListener('click',event=>{if(this.suppressClick){event.preventDefault();event.stopPropagation();this.suppressClick=false;}},{capture:true,signal});
   const pause=this.querySelector('[data-czh-pause]');pause.textContent=this.paused?pause.dataset.playLabel:pause.dataset.pauseLabel;
   on(pause,'click',()=>{this.paused=!this.paused;pause.textContent=this.paused?pause.dataset.playLabel:pause.dataset.pauseLabel;});
   on(this,'mouseenter',()=>{this.hovered=true;});on(this,'mouseleave',()=>{this.hovered=false;});
   this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!this.drag&&!this.contains(document.activeElement)&&!document.hidden)this.move(1);},Number(this.dataset.interval)||4000);
  }
  move(direction){const step=(this.track.firstElementChild?.getBoundingClientRect().width||220)+parseFloat(getComputedStyle(this.track).gap||0);const end=this.track.scrollWidth-this.track.clientWidth;let target=this.track.scrollLeft+step*direction;if(target>end-2&&direction>0&&this.track.scrollLeft>=end-2)target=0;else if(target<0)target=end;this.track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  disconnectedCallback(){this.abort?.abort();this.abort=null;clearInterval(this.timer);}
 });
}
if(!customElements.get('cz-tag-products')){
 customElements.define('cz-tag-products',class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;this.abort=new AbortController();this.cache=new Map();this.sequence=0;const signal=this.abort.signal;
   this.tabs=[...this.querySelectorAll('[data-czh-tab]')];this.panel=this.querySelector('[data-czh-panel]');this.more=this.querySelector('[data-czh-view-more]');this.next=this.querySelector('[data-czh-products-next]');
   this.tabs.forEach((tab,i)=>{
    tab.addEventListener('click',event=>{if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();this.activate(tab);},{signal});
    tab.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight')next=(i+1)%this.tabs.length;else if(event.key==='ArrowLeft')next=(i-1+this.tabs.length)%this.tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;event.preventDefault();this.tabs[next].focus();this.activate(this.tabs[next]);},{signal});
   });
   this.next.addEventListener('click',()=>{const rail=this.panel.querySelector('.czh-product-rail');if(rail)rail.scrollBy({left:rail.clientWidth,behavior:'smooth'});},{signal});
   if(this.tabs[0])this.activate(this.tabs[0]);
  }
  async activate(tab){
   const sequence=++this.sequence;this.request?.abort();const request=new AbortController();this.request=request;const timer=setTimeout(()=>request.abort(),20000);
   this.tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});this.panel.setAttribute('aria-labelledby',tab.id);this.panel.setAttribute('aria-busy','true');this.next.hidden=true;
   const url=new URL(tab.href,location.origin);if(url.origin!==location.origin){clearTimeout(timer);return;}this.more.href=url.pathname;url.searchParams.set('section_id','cz-home-results');url.searchParams.set('sort_by','created-desc');
   try{
    let content=this.cache.get(url.href);
    if(!content){const response=await fetch(url,{signal:this.request.signal});if(!response.ok)throw Error('Unable to load products');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const results=doc.querySelector('[data-czh-results]');if(!results)throw Error('Missing results');content=results.innerHTML;this.cache.set(url.href,content);}
    if(sequence!==this.sequence||!this.isConnected)return;this.panel.innerHTML=content;
    const rail=this.panel.querySelector('.czh-product-rail');this.next.hidden=!rail||rail.scrollWidth<=rail.clientWidth+2;
   }catch(error){if(sequence!==this.sequence||!this.isConnected)return;const message=document.createElement('p');message.className='czh-status';message.setAttribute('role','status');message.textContent=this.dataset.error;this.panel.replaceChildren(message);}
   finally{clearTimeout(timer);if(sequence===this.sequence)this.panel.setAttribute('aria-busy','false');}
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.request?.abort();this.sequence++;}
 });
}
  } catch(e) { console.error(e); }
})();

})();
